module.exports = __webpack_public_path__ + "img/logo-icon.3a84d4e4.png";